import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import "./constants/global.css";
import "shepherd.js/dist/css/shepherd.css";
import "./tour/tourTheme.css";
import App from "./app/App";
import reportWebVitals from "./reportWebVitals";

import FontStyles from "./assets/fonts/fonts";

// Sentry error monitoring (must init before React renders)
import { initSentry } from "./sentry";
initSentry();

// MUI X License
import { LicenseInfo } from "@mui/x-license";
LicenseInfo.setLicenseKey(import.meta.env.VITE_MUI_X_LICENSE_KEY);

// Handle chunk loading errors by reloading the page
// This happens when a user has an old version of the app during a deployment
window.addEventListener("error", (event) => {
  // Check if this is a chunk loading error
  if (
    event.message?.includes("Loading chunk") ||
    event.message?.includes("ChunkLoadError") ||
    event.message?.includes("Failed to fetch dynamically imported module") ||
    event.message?.includes("is not a valid JavaScript MIME type") ||
    (event.filename?.includes(".chunk.js") && event.message?.includes("Unexpected token"))
  ) {
    console.warn("Chunk load error detected, reloading page...");
    // Reload the page to get the new chunk files
    window.location.reload();
  }
});

// Also handle unhandled promise rejections for chunk loading errors
window.addEventListener("unhandledrejection", (event) => {
  if (
    event.reason?.message?.includes("Loading chunk") ||
    event.reason?.message?.includes("Failed to fetch dynamically imported module") ||
    event.reason?.message?.includes("is not a valid JavaScript MIME type") ||
    event.reason?.name === "ChunkLoadError"
  ) {
    console.warn("Chunk load error detected in promise, reloading page...");
    window.location.reload();
  }
});

// React 18 createRoot API
const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <React.Fragment>
    <FontStyles />
    <App />
  </React.Fragment>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
